import InvoiceType from '../InvoiceType';

export default class ProjectBilling {
    id: number;
    dayRate: number;
    mileageRate: number;
    invoiceFormat: string;
    billByMethod: string;
    invoicePeriod: string;
    totalAFE: number;
    totalAFEused: number;
    invoiceSupplement: string;
    mealReceiptsRequired: boolean;
    breakdownOfficeExpenses: boolean;
    chargeBackupPersonnel: boolean;
    chargeOfficeExpenses: boolean;
    doNotBillServicesOrExpenses: boolean;
    clientLMEmailOnInvoice: boolean;
    billToOtherProject: boolean;
    printPreparedDate: boolean;
    chargeBackupOfficeAtCost: boolean;
    chargeBackupOfficeRate?: number;
    backupOfficePercent?: number;
    backupOfficeRate?: number;
    chargeBpPercentage?: number;
    clientsForm: boolean;
    dlcForm: boolean;
    recap: boolean;
    invoiceDiscountBonusPercent: boolean;
    billingFrequency: boolean;
    enterClientAFENoOnTimeSheet: boolean;
    enterClientProjectNoOnTimeSheet: boolean;
    enterClientProjectNameOnTimeSheet: boolean;
    enterClientAccountNoOnTimeSheet: boolean;
    arInvoiceGrouping: boolean;
    mileageDestinationRequired: boolean;
    unitTaskEntryRequired: boolean;
    turnkeyBilling: boolean;
    doNotRoundDaysOnBackupOffice: boolean;
    printBillingPersonnelNameOnInvoice: boolean;
    printAFEStatusOnInvoiceCoverLetter: boolean;
    doNotExceedProject: boolean;
    totalAFEWarningPercentage: boolean;
    billingInstruction?: string;
    invoiceDueDays?: number;

    invoiceTypes?: InvoiceType[];
    removeInvoiceTypeIds?: number[];
}



// WEBPACK FOOTER //
// ./src/models/projectSettings/ProjectBilling.ts